import React from 'react';
import styled, { css } from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { Card } from '@mlc/web-ui-toolkit';
import { ScreenSize } from '../../../../enums';

export const ImageCard = styled(({ backgroundImg, ...restProps }) => (
	<Card {...restProps} />
))`
	background: url(${(p: { backgroundImg: string }) => p.backgroundImg});
	background-position: top center;
	min-height: 350px;

	@media (max-width: ${ScreenSize.medium}) {
		background: none;
		background-color: ${palette.mlcBlack};
		min-height: auto;
	}
`;

export const FlexBox = styled.div`
	display: flex;
	flex-direction: row;

	@media (max-width: ${ScreenSize.medium}) {
		flex-direction: column;
	}
`;

interface FlexProps {
	flexSize?: number;
	left?: boolean;
	right?: boolean;
}

const leftTileStyles = css`
	border-right: 1px solid #4e4f4e;
	padding-right: 30px;

	@media (max-width: ${ScreenSize.medium}) {
		border-right: none;
		padding: 0;
	}
`;

const rightTileStyles = `
    padding-left: 25px;

    @media (max-width: ${ScreenSize.medium}) {
        padding: 40px 0;
    }

    @media (max-width: ${ScreenSize.xSmall}) {
        padding: 40px 0;
    }
`;

export const Tile = styled.div`
	flex: ${(p: FlexProps) => p.flexSize};
	padding-right: 30px;
	padding-top: 20px;
	${(p: FlexProps) => (p.left ? leftTileStyles : rightTileStyles)}
`;
